import { render, staticRenderFns } from "./Factory.vue?vue&type=template&id=96410cce&scoped=true&"
import script from "./Factory.vue?vue&type=script&lang=js&"
export * from "./Factory.vue?vue&type=script&lang=js&"
import style0 from "./Factory.vue?vue&type=style&index=0&id=96410cce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96410cce",
  null
  
)

export default component.exports